export default __webpack_public_path__ + "static/media/w.8646b829.png";